import GCalListItem from "./GCalListItem.tsx";
import {Container, Fab, Typography} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import AddGCalIntegrationDialog from "./AddGCalIntegrationDialog.tsx";
import {useCallback, useEffect, useState} from "react";
import {eventerConsoleApiClient, GCalIntegration} from "../../../../../api-client/EventerConsoleApiClient.ts";
import FullSizeBox from "../../../../../../appfw/ui/components/FullSizeBox.tsx";
import {fabOverlayStyle} from "../../../../EventerConsoleApp.styles.ts";

export interface GCalListProps {
    accountId: string;
}

export default function GCalList(props: GCalListProps) {

    const [gCalIntegrations, setGCalIntegrations] = useState<undefined | GCalIntegration[]>()

    useEffect(() => {
        let active = true
        eventerConsoleApiClient.getGCalIntegrations({accountId: props.accountId})
            .then((gCalIntegrations) => {
                if (active) {
                    setGCalIntegrations(gCalIntegrations)
                }
            })
        return () => {
            active = false
        }
    }, [props.accountId])

    // use memos / callbacks?
    const [open, setOpen] = useState(false);
    const handleClickOpen = useCallback(() => {
        setOpen(true);
    }, [])

    const handleClose = useCallback((addedGCalIntegration?: GCalIntegration) => {
        setOpen(false)
        if (gCalIntegrations && addedGCalIntegration) {
            setGCalIntegrations([...gCalIntegrations, addedGCalIntegration])
        }
        console.log("closed: ", addedGCalIntegration)
    }, [gCalIntegrations])

    const handleUpdate = useCallback((updatedIntegration: GCalIntegration) => {
        if (!gCalIntegrations) {
            return
        }
        let modified = false
        let updatedIntegrations = gCalIntegrations.map((integration) => {
            if (integration.id === updatedIntegration.id) {
                modified = true
                return updatedIntegration
            } else {
                return integration
            }
        })
        if (modified) {
            setGCalIntegrations(updatedIntegrations)
        }
    }, [gCalIntegrations])

    const handleDelete = useCallback((id: string) => {
        if (!gCalIntegrations) {
            return
        }
        const updatedGCalIntegrations = gCalIntegrations
            .filter((it) => it.id !== id)
        if (updatedGCalIntegrations.length !== gCalIntegrations.length) {
            setGCalIntegrations(updatedGCalIntegrations)
        }
    }, [gCalIntegrations])

    const gCalEntries =
        gCalIntegrations?.map((gCalIntegration) => {
            return <GCalListItem
                key={gCalIntegration.id}
                accountId={props.accountId}
                gCalIntegration={gCalIntegration}
                onUpdate={handleUpdate}
                onDelete={() => handleDelete(gCalIntegration.id)}
            />
        })

    return (
        <FullSizeBox>
            <>
                {(gCalIntegrations?.length === 0) &&
                    <Typography variant={'h6'} sx={{marginTop: '6rem'}}>
                        Keine Kalender verbunden
                    </Typography>
                }

                <Container maxWidth="md">
                    {gCalEntries}
                </Container>

                <Fab color="primary" aria-label="add" sx={fabOverlayStyle} onClick={handleClickOpen}>
                    <AddIcon/>
                </Fab>
                <AddGCalIntegrationDialog accountId={props.accountId} open={open} onClose={handleClose}/>
            </>
        </FullSizeBox>
    )
}
